export const completeTrack = async (setTracksCompleted, tracksCompleted, id) => {
    const result = await fetch(
      `/api/user/${id}/trackCompleted`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: `${localStorage.getItem("username")}`,
        }),
      }
    );
    const body = await result.json();
    //add id to tracksCompleted
    setTracksCompleted([...tracksCompleted, id]);

  };

export const removeTrack = async (setTracksCompleted, tracksCompleted, id) => {
    const result = await fetch(`/api/user/${id}/removeTrack`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: `${localStorage.getItem("username")}`,
      }),
    });
    //remove id from tracksCompleted
    setTracksCompleted(tracksCompleted.filter((track) => track !== id));
    const body = await result.json();
  };

  
export const completeLesson = async (id, setLessonsCompleted, lessonsCompleted) => {
    const result = await fetch(
      `/api/user/${id}/lessonCompleted`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: `${localStorage.getItem("username")}`,
        }),
      }
    );
    const body = await result.json();
    //add id to lessonsCompleted
    setLessonsCompleted([...lessonsCompleted, id]);

  };

export const removeLesson = async (id, setLessonsCompleted, lessonsCompleted) => {
    const result = await fetch(
      `/api/user/${id}/removeLesson`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: `${localStorage.getItem("username")}`,
        }),
      }
    );
    const body = await result.json();
    //remove id from lessonsCompleted
    setLessonsCompleted(lessonsCompleted.filter((lesson) => lesson !== id));

  };